import { TableCell, TableRow } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { SwissGermanLocale, SwissTimeZone } from "../../../../data/constants";
import { ExamType, ExamTypeTranslationKey } from "../../../../model/Exam";
import { ModuleExamForSignupViewModel } from "../../../../model/ExamSignup/ExamSessionForSignupViewModel";
import { ModuleSelectionViewModel } from "../../../../model/ExamSignup/ModuleSelectionViewModel";
import { GetTranslatedValueIntl } from "../../../../model/Shared/TranslatedValue";
import TranslatedMessage from "../../../translations/TranslatedMessage";

type SummaryExamRow = {
  module: ModuleSelectionViewModel;
  examReference: ModuleExamForSignupViewModel;
};

const SummaryExamRow: React.FunctionComponent<SummaryExamRow> = ({ module, examReference }) => {
  const intl = useIntl();

  const isTermPaper = examReference.type === ExamType.TermPaper;
  const examDetails = isTermPaper ? undefined : module.examDetails?.find((d) => d.examId === examReference.id);

  const displayDate = examDetails?.examDayDate
    ? new Date(examDetails?.examDayDate).toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone })
    : "";

    const getLocationLanguage = () => {
      if (isTermPaper) return "";
      if (!examDetails?.language) return "";
      return `(${examDetails.language})`;
    }

  return (
    <TableRow>
      <TableCell />
      <TableCell>{GetTranslatedValueIntl(intl, examReference.name)}</TableCell>
      <TableCell>
        <TranslatedMessage id={ExamTypeTranslationKey[examReference.type]} />
      </TableCell>
      <TableCell>{isTermPaper ? "-" : examDetails?.locationName} {getLocationLanguage()}</TableCell>
      <TableCell>{isTermPaper ? "-" : displayDate}</TableCell>
      <TableCell />
      <TableCell />
    </TableRow>
  );
};

export default SummaryExamRow;
